// 2DO Need to remove this enum whereever we used
// because now we are using the dynamic enum, that we get it from API

export enum CredReqType {
  Initial = 'Initial',
  ReCredentialing = 'ReCredentialing',
  OffCycle = 'OffCycle'
}

export const CredReqTypeLabel: ObjectType<string> = {
  Initial: 'Initial Credentialing',
  ReCredentialing: 'Re-Credentialing',
  OffCycle: 'Off-Cycle'
};

export const CredReqTypeMenuLabel: ObjectType<string> = {
  Initial: 'Initial Cred',
  ReCredentialing: 'Re-Cred',
  OffCycle: 'Off-Cycle'
};

export default CredReqType;
